export default __webpack_public_path__ + "/Themes/BrendonV2/Content/css/style.css";